export class PhotoswipeImage {
  src: string;
  w: number;
  h: number;

  constructor(src: string, w: number, h: number) {
    this.src = src;
    this.w = w;
    this.h = h;
  }
}
